<ng-container *cidContentLoader="contentLoading">
  <h1>{{ "GROUP_SELECTION.WELCOME_HEADER" | translate }}</h1>
  <!--<h1 class="heading primary">{{ queryParams.userid_hint }}</h1>-->
  <p class="mb30">{{ "GROUP_SELECTION.WELCOME_LABEL" | translate }}</p>

  <div class="section">
    <ul>
      <li *ngFor="let item of groupHolder">
        <div fxLayout="row" fxLayoutAlign="space-around center" class="inline-list">
          <div class="cardLogo" *ngIf="item.logoURL">
            <img  class="group-img space-left2" [src]="item.logoURL" alt="alt"/>
          </div>
          <app-button [class.w-full]="!item.logoURL" [btnOption]="getButtonOption(item)" (clickEvent)="clickRedirect(item.groupId)"></app-button>
        </div>
      </li>
    </ul>
    <div *ngIf="navActive" class="group-section group-nav" fxLayout="row" fxLayoutAlign="space-around center">
      <app-button (clickEvent)="prev()" class="prev-button" [btnOption]="buttonOptions.prevGroup"> </app-button>
      <app-button (clickEvent)="next()" class="next-button" [btnOption]="buttonOptions.nextGroup"> </app-button>
    </div>
    <div *ngIf="errorMessage" class="group-section" fxLayout="row" fxLayoutAlign="space-around center">
      <div class="mat-error center">{{ 'ERROR.MSG' | translate }}</div>
    </div>
    <div class="section btn-group">
      <a (click)="commonFunc.getRedirectedByRequestId()"
      ><label>{{ "CANCEL" | translate }}</label></a
      >
    </div>
  </div>
</ng-container>
